const fr = {
  Dashboard: 'Tableau de bord',
  Catalog: 'Catalogue',
  Catalogs: 'Catalogues',
  Quotes: 'Devis',
  Clients: 'Clients',
  Management: 'Gestion',
  Docs: 'Documents',
  Tutorials: 'Tutoriels',
  Tenant: 'Espace client',
  MFA_Management: 'Gestion du MFA',
  Videos: 'Vidéos',
  User_Guide: "Guide de l'utilisateur",
  Upload_Video: 'Importer une vidéo',
  Upload_File: 'Importer un fichier',
  Select_Categories: 'Sélectionner les catégories',
  Select_Access_By: 'Sélectionner accès par',
  Assign_User: 'Attribuer un utilisateur',
  January: 'Janvier',
  February: 'Février',
  March: 'Mars',
  April: 'Avril',
  May: 'Mai',
  June: 'Juin',
  July: 'Juillet',
  August: 'Août',
  September: 'Septembre',
  October: 'Octobre',
  November: 'Novembre',
  December: 'Décembre',
  Validity_period: 'Période de validité',
  Project_Name: 'Nom du projet',
  Engagement_Name: 'Nom de la mission',
  Engagement_Model: 'Modèle de mission',
  Customer: 'Client',
  OTP: 'OTP',
  Overdue_by: 'En retard de',
  Type: 'Type',
  Search: 'Rechercher',
  Rows_Per_Page: 'Lignes par page',
  To_Duplicate: 'Dupliquer',
  No_Client_Found: 'Aucun_client_trouvé',
  Scope_Id: 'Périmètre',
  Consultant_Fullname: 'Consultant',
  Delivery_Manager_Fullname: 'Nom_Complet_du_Delivery_Manager',
  delivery_manager: 'Delivery Manager',
  Client_Fullname: 'Client',
  Forecasted_Date: 'Date prévue',
  Delivery_Date: 'Date de livraison',
  Complexity_Name: 'Complexité',
  Pending: 'En attente',
  Drafted: 'Brouillon',
  Archived: 'Archivé',
  Archive: 'Archiver',
  Production: 'Production',
  Management_Catalog: 'Catalogue',
  Management_Material: 'Assistance Technique',
  Material_Drafts: 'Brouillons',
  Material_Production: 'Production',
  Material_Closed: 'Clôturé',
  Material_Deleted: 'Supprimé',
  Closed: 'Clôturé',
  Validated: 'validé',
  Actions: 'Actions',
  Video: 'Vidéo',
  Title: 'Titre',
  Access_By: 'Accès par',
  File: 'Fichier',
  Comments: 'Commentaires',
  Amount: 'Montant',
  Cancellation_Reason: "Raison de l'annulation",
  Modification_Reason: 'Raison de la modification',
  Workunit_Name: "Nom de l'Unité d'Oeuvre",
  Workunit_Reference: "Référence de l'Unité d'Oeuvre",
  Assess_And_Sign: 'Évaluer et signer',
  Approve_And_Sign: 'Approuver et signer',
  Cancelation_reason: 'Raison de l’annulation',
  No_workunit_in_catalog: 'Aucune unité d’œuvre dans le catalogue',
  Validated_Bm: 'Validé par le Business Manager',
  Client_Acceptance_At_Completion: 'Accepté par le client à l’achèvement',
  Estimated_At_Completion: 'Estimé à Terminaison',
  Representative: 'Représentant',
  Nothing: 'Aucun',
  Cancel_Validation: 'Annuler la validation',
  Deliverables_Evaluation: 'Évaluation les livrables',
  Accept: 'Accepter',
  Deliverables_Acceptance: 'Acceptation des livrables',
  Validate_Selected_Deliverables: 'Valider les livrables sélectionnés',
  Deliverables_Validation: 'Validation des livrables',
  Deliverable_Submission: 'Soumission des livrables',
  Cancel_Submission: 'Annuler la soumission',
  Submit_Selected_Deliverables: 'Soumettre les livrables sélectionnés',
  Cancel_Selected_Deliverables: 'Annuler les livrables sélectionnés',
  Cancel_Submission_Selected_Deliverables: 'Annuler la soumission du/de(s) livrable(s) sélectionné(s)',
  Cancel_Validation_Selected_Deliverables: 'Annuler la validation du/des livrable(s) sélectionné(s)',
  WU_Parameters: "Paramètres de l'unité d'oeuvre",
  Quick_action: 'Action',
  Quick_view: 'Aperçu',
  Items_Selected: 'éléments sélectionnés',
  Add_Client: 'Ajouter un client',
  Add_Catalog: 'Nouveau catalogue',
  Deliverable_Projection: 'Prévision des livrables',
  Month_Should_Be_Inferior_To: 'Le mois doit être inférieur à',
  Date_Should_Be_Superior_To: 'La date doit être supérieure à',
  Date_Should_Be_Inferior_To: 'La date doit être inférieure à',
  Date_Invalid: 'Date invalide',
  Edit_Order: 'Modifier la commande',
  Start_Frequency_Date: 'Date de début de la récurrence',
  End_Frequency_Date: 'Date de fin de la récurrence',
  No_Scope: 'Aucun périmètre',
  Deliverable_Name: 'Nom du livrable',
  Contract_Reference: 'Référence Contractuelle',
  Order_Price: 'Prix de la commande',
  Apply_Discount: 'Appliquer une remise',
  Final_Price: 'Prix final',
  Quote_Reference: 'Référence du devis',
  Confirm_Delete_Deliverables: 'Êtes-vous sûr de vouloir supprimer ce livrable ?',
  Text_Not_Affilied_1: ' ',
  Text_Not_Affilied_2: ' ',
  Initial_Deliverable_Date: 'Date de livraison initiale',
  Reason: 'Raison',
  Enter_Text_Here: 'Entrez le texte ici',
  New_Expected_Date: 'Nouvelle date prévue',
  Modify_Deliverable: 'Modifier le livrable',
  Client_Not_Indicated: 'Client non indiqué',
  Error_Input_Date_Max_Date_Inferior_Start_Date: 'La date de fin doit être égale ou postérieure à la date de début',
  Trigger_Validation_Summary: 'Déclencher le résumé de la validation',
  Quote_Summary: 'Résumé du devis',
  Select_Catalog: 'Sélectionnez un catalogue',
  Affair_Date: "Date de l'affaire",
  Engagement_Date: 'Date de la mission',
  Project_Name: 'Nom du projet',
  Project_Ref: 'réf. du projet',
  Otp_Ref: 'OTP',
  Text2_Chrono_Drawer: 'Text2_chrono_drawer',
  Text2_Chrono_Drawer: 'Text2_chrono_drawer',
  Text2_Chrono_Drawer: 'Text2_chrono_drawer',
  Text2_Chrono_Drawer: 'Text2_chrono_drawer',
  Text1_Affair_Drawer: 'Text1_affair_drawer',
  Text1_Client_Drawer: 'Text1_client_drawer',
  Complete_Affair: "Finaliser l'affaire",
  Quarter_Displayed: 'Afficher par trimestre',
  Forecasted_Date: 'Date prévue',
  Reforecasted_Date: 'Date replanifiée',
  Forecasted_Delivery: 'Livraison prévisionnelle',
  Select_Forecasted_Date: 'Sélectionner la date prévue',
  Affair_Not_Indicated: 'Affaire non indiquée',
  Draft_Reference: 'Référence brouillon',
  Draft_Reference_Text: 'Référence brouillon texte',
  Go_Ahead: 'Continuer',
  Create_Work_Unit_To_Proceed: 'Créer une Unité d’Oeuvre pour continuer.',
  CONTACT_ADMIN_CONFIG_TENANT_WORKMONTH: 'Données manquantes. Contactez l’administrateur de l’espace',
  To_Deliver: 'À livrer',
  Acceptation_With_Reserve: 'Acceptation avec réserve',
  Validated_With_Reserve: 'Validé avec réserve',
  Delivery_manager: 'Delivery Manager',
  Validate_Order: 'Valider le devis',
  Current_Order_Datagrid_No_Row_Overlay: "Absence de superposition dans la table actuelle de l'order",
  All_Project: 'Tous les projets',
  Save_For_Later: 'Enregistrer pour plus tard',
  Order_Summary: 'Résumé de la commande',
  My_Order: 'Ma commande',
  Enter_Professional_Info_Tm: 'Informations professionnelles',
  Engagement_By_Name_Tm: 'Mission par nom',
  Engagement_By_Name_Text_Tm: 'Mission par nom texte',
  Engagement_By_Otp_Code_Tm: 'Engagement par code OTP',
  Engagement_By_Otp_Code_Text_Tm: 'Mission par code OTP texte',
  Reference_Chrono_Tm: 'Référence (chrono)',
  Reference_Chrono_Text_Tm: 'Référence (chrono) texte',
  Representative_Select_Tm: 'Sélectionner un représentant',
  Representative_Select_Text_Tm: 'Sélectionner un représentant texte',
  Project_Name_Tm: 'Nom du projet',
  Project_Name_Text_Tm: 'nom du projet texte',
  Spec_Reference_Tm: 'Référence spec',
  Spec_Reference_Text_Tm: 'Référence spec texte',
  Start_Date_Tm: 'Date de début',
  Date_Text_Tm: 'Date texte',
  End_Date_Tm: 'Date de fin',
  Purchase_Order: 'Numéro de commande',
  Purchase_Order_Text_Tm: 'Numéro de commande texte',
  Scopes_Tm: 'Périmètre(s)',
  Scopes_Text_Tm: 'Périmètre texte',
  Stake_Holders_Tm: 'Parties prenantes',
  Delivery_Managers_Tm: 'Delivery Manager(s)',
  Head_Text_Tm: "texte d'en-tête",
  Consultants_Tm: 'Consultant(s)',
  Client_Name_Tm: 'Nom du client',
  Client_Connection_To_Platform_Tm: 'Connexion du client à la plateforme',
  Enter_Affair_Parameters: 'Entrer les paramètres de la mission',
  Create_New_Order: 'Créer une nouvelle commande',
  Create_Time_Material_Order_Tm: 'Créer une commande en Assistance Technique',
  Save_As_Draft_Tm: 'Enregistrer comme brouillon',
  Validate_Tm: 'Valider',
  Cancel_Tm: 'Annuler',
  Affair_Parameters: 'Paramètres de la mission',
  Edit_Deliverables: 'Modifier les livrables',
  Some_Deliverable_Cannot_Be_Edited: 'Certains livrables ne peuvent pas être modifiés',
  Reload_User_On_Tenant_Permissions: 'Recharger les autorisations de l’utilisateur pour cet espace client',
  Reload_permissions: 'Recharger les autorisations',
  Users_Roles: 'Rôles des utilisateurs',
  Customer_Administration: 'Administration client',
  Permissions: 'Autorisations',
  Search_By_Role: 'Rechercher par rôle',
  Reset_Filters: 'Réinitialiser les filtres',
  Delete_deliverables: 'Supprimer le(s) livrable(s)',
  These_Deliverables_Are_Not_Deletable: 'Impossible de supprimer le(s) livrable(s) sélectionné(s)',
  Some_Of_These_Deliverables_Are_Not_Deletable: 'Certains livrables ne peuvent pas être supprimés',
  Name_Deliverable: 'Nom du livrable',
  Deliverable_Reference: 'Référence du livrable',
  Deliverable_Description: 'Description du livrable',
  Deliverable_Content: 'Contenu du livrable',
  Users_Gestions: 'Gestion des utilisateurs',
  Content_New_Deliverable: 'Contenu du nouveau livrable',
  Roles: 'Rôles',
  Drag_And_Drop_Text_Catalog: 'Glissez-déposez ici le catalogue',
  Download_Template: 'Télécharger le Template',
  Customer_Validation: 'Validation client',
  Select_Delivery_Date: 'Sélectionner la date de livraison',
  Delivery_Date: 'Date de livraison',
  not_attributed: 'Non attribué',
  Consultant_Submission: 'Soumission du consultant',
  Clear_Filters: 'Effacer les filtres',
  Excellent: 'Excellent',
  Above_Expectations: 'Supérieur aux attentes',
  Average: 'Conforme aux attentes',
  Below_Expectations: 'Inférieur aux attentes',
  Not_Acceptable: 'Inacceptable',
  Partial_Duplicate: 'Duplication partielle',
  Save_Change: 'Enregistrer les modifications',
  Not_Submited: 'Non soumis',
  Refused_DC: 'Refusé par le DM',
  Reserve_DC: 'Validé avec réserve par le DM',
  Refused_Customer: 'Refusé par le client',
  Reserve_Customer: 'Accepté avec réserve par le client',
  Validated_DC: 'Validé par le DM',
  Validated_Customer: 'Accepté par le client',
  Diffuse_External: 'Diffusion externe',
  Is_Private: 'Privé',
  Charge: 'Charge de travail',
  Welcome_Back: 'Bon retour',
  Mark_All_As_Read: 'Tout marquer comme lu',
  Client_Acceptance: 'Acceptation client',
  Send_Rating: 'Envoyer l’évaluation',
  See_All_Notifications: 'Voir toutes les notifications',
  See_Less_Notifications: 'Voir moins de notifications',
  More_Filters: 'Plus de filtres',
  Re_Submit: 'Soumettre à nouveau',
  Validate_And_Assess: 'Valider et évaluer',
  Validate_With_Reserve: 'Valider avec réserve',
  To_Be_Submitted: 'À soumettre',
  To_Be_Validated: 'À valider',
  To_Be_Confirmed: 'À accepter',
  To_Be_Assessed: 'À évaluer',
  Mission_Refusal_Message: 'Un livrable a été refusé',
  Mission_Accept_Partial_Message: 'Message mission partiellement acceptée',
  Mission_Just_Shipped_Message: 'message_mission_juste_expédié',
  Mission_Just_Confirmed: 'Mission confirmée',
  Scope_New_Assignation_Message: 'message de nouvelle affectation de périmètre',
  Mission_New_Client_Assignation_Message: 'message_attribution_nouvelle_mission_client',
  Mission_New_Consultant_Assignation_Message: 'message_mission_nouveau_consultant',
  Mission_Overdue_Message: 'message_mission_en_retard',
  Mission_Bad_Ranking_Message: 'Un livrable a été mal noté',
  Submit_Again: 'Soumettre de nouveau',
  New_User: 'Nouvel utilisateur',
  Save_User: "Enregistrer l'utilisateur",
  Last_Name: 'Nom de famille',
  First_Name: 'Prénom',
  Position: 'Poste',
  Mail: 'E-mail',
  Department: 'Département',
  Direction: 'Direction',
  Tenants: 'Espaces clients',
  Update_Client: 'Mettre à jour le client',
  Updating: 'Mise à jour...',
  Creating: 'Création...',
  Bm: 'Business Manager',
  Consultant: 'Consultant',
  Customer: 'Client',
  Head: 'Tête',
  Admin: 'Administrateur',
  support_bu: 'Support BU',
  Delivery_Coordinator: 'Delivery Coordinator',
  DDCC: 'DDCC',
  Bu: 'BU',
  Support_BU: 'Support BU',
  Open_Access: 'Ouvrir l’accès',
  '2_characters_Minimun': '2 caractères minimum',
  Name_Catalog: 'Nom du catalogue',
  Create_An_Order: 'Créer une mission',
  Order_Parameter: 'Paramètres de la mission',
  Save_Modifications: 'Enregistrer les modifications',
  Submit_Refusal: 'Soumettre le refus',
  Submit_Accepted: 'Soumettre l’acceptation',
  Accept_With_Reserve: 'Accepter avec réserve',
  Leave_A_Comment: 'Laisser un commentaire',
  Select_A_Consultant: 'Sélectionner un consultant',
  Select_A_Scope: 'Sélectionner un périmètre',
  Select_A_Customer: 'Sélectionner un client',
  Validity_To: 'Valide jusqu’au',
  Validity_From: 'Valide à partir du',
  Internal_Contact: 'Contact interne',
  Create_Workunit: 'Créer une unité d’œuvre',
  Client_Catalog: 'Catalogue Client',
  Validity_Period: 'Période de validité',
  Last_Updated: 'Dernière mise à jour',
  Create_Catalog: 'Créer un catalogue',
  Update_Catalog: 'Mettre à jour le catalogue',
  Create_Categories: 'Créer des catégories',
  Catalog_Workunits: "Unités d'œuvre du catalogue",
  Scope_Name: 'Périmètre',
  Create_Client: 'Créer un client',
  Ref_Order: 'Référence de la mission',
  Reference_Spec: 'Référence de la spécification',
  Mission_Period: 'Période de la mission',
  Add_A_New_Order: 'Ajouter une nouvelle mission',
  Go_To_Selection_Workunits: "Aller à Sélectionner les Unités d'oeuvre",
  Go_To_Summary: 'Aller à Résumé',
  Go_To_Parameters_Workunits: "Aller aux Paramètres des unités d'oeuvre",
  Go_To_Parameters_Affectations_Workunits: "Aller aux paramètres d'affectation des unités doeuvre",
  Remove_This_Element: 'Supprimer cet élément',
  Cant_Remove_Because_Used: 'Impossible de supprimer cet élément, car il est utilisé',
  Is_Minimun_Because_Assignations: 'est le minimum, car cette valeur est utilisée dans des affectations',
  Ref_Order_Items: 'Référence des éléments de la mission',
  Ref_Workspace: 'Référence de l’espace de travail',
  Total_Charge: 'Charge de travail totale',
  Otp_Code: 'Code OTP',
  Choose_By_OTP_Code: "Choisir l'engagement par OTP",
  Choose_By_Name: "Choisir l'engagement par nom",
  Affair_Name: "Nom de l'affaire",
  Total_Price: 'Prix total',
  Not_Defined: 'Non défini',
  Validated_By: 'Validé par',
  Po_Ref: 'Réf. de la commande',
  Number_Of_Workunits: 'Nombre d’unités d’œuvre',
  Name_Spec: 'Nom de la spécification',
  Ref_Spec: 'Référence de la spécification',
  Edit_Order_Workunit: "Modifier les Unité d'Oeuvre",
  Start_Date: 'Date de début',
  End_Date: 'Date de fin',
  Add_Selected: 'Ajouter la sélection',
  Edit_Workunit: "Modifier l'unité d'oeuvre",
  Price: 'Prix',
  Load_Estimation: 'Estimation de charge',
  Select_validity_dates: 'Sélectionner les dates de validité',
  Add_Comment: 'Ajouter un commentaire',
  Accept_Standard: 'Acceptation Standard',
  Level_Standard: 'Niveau standard',
  Deliverables: 'Livrables',
  Add_Workunit_Livrable: 'Ajouter un livrable',
  Create_Workunit: 'Créer une unité d’œuvre',
  Reference_Of_Workunit: "Référence de l'unité d'oeuvre",
  Name_Of_New_Workunit: "Nom de l'unité d'oeuvre",
  Description_New_Workunit: "Description de l'unité d'oeuvre",
  Input_New_Workunit: "Données d'entrée de l'Unité d'Oeuvre",
  Output_New_Workunit: "Données de sortie de l'Unité d'Oeuvre",
  LEVEL_STANDARD_WORKUNIT: 'Description du niveau standard',
  Accept_Standard_Workunit: 'Description des critères d’acceptation',
  Outputs: 'Sorties',
  Inputs: 'Entrées',
  Submitted: 'SOUMIS',
  Accepted: 'Accepté',
  Client_Accepted: 'Accepté par le client',
  Refused: 'Refusé',
  Client_Refused: 'Refusé par le client',
  Reset_Filter: 'Réinitialiser le filtre',
  Description_New_Deliverable: 'Description du nouveau livrable',
  Validate_The_Modifications: 'Valider les modifications',
  Disconnect: 'Se déconnecter',
  Active_User_Avatar: "Avatar de l'utilisateur",
  Close: 'Fermer',
  Back_Up: 'Retour',
  Saving_Location: 'Emplacement de sauvegarde',
  Estimate_Charge: 'Charge estimée',
  Optional: 'Optionnel',
  Order_Number: 'Commande n°',
  Add_A_Number: 'Ajouter un numéro',
  Date_Delivery: 'Date de livraison',
  Add_This_New_Deliverable: 'Ajouter ce nouveau livrable',
  Select_The_Start_Date: 'Sélectionner la date de début',
  Edit_Deliverable: 'Modifier le livrable',
  Generate_Sheet: 'Exporter',
  Duplicate_Deliverable: 'Dupliquer un livrable',
  Done: 'Terminé',
  Open: 'Ouvert',
  One_Time: 'Ponctuel',
  Weekly: 'Hebdomadaire',
  Monthly: 'Mensuel',
  Other: 'Autre',
  Status: 'Statut',
  Name: 'Nom',
  Reference: 'Référence',
  Edit: 'Modifier',
  Deliverable_Date: 'Date initiale',
  Frequency: 'Fréquence',
  Validated: 'Validé',
  Rating: 'Évaluation',
  Comment: 'Commentaire',
  Action: 'Action',
  Add_New_Deliverable: 'Ajouter un nouveau livrable',
  Reference_Of_New_Deliverable: 'Référence du livrable',
  Name_Of_New_Deliverable: 'Nom du livrable',
  Added: 'Ajouté',
  Custom: 'Personnalisé',
  Updated: 'Mis à jour',
  Cancelled: 'Annulé',
  Tags: 'Étiquettes',
  Reference: 'Référence',
  Name: 'Nom',
  Workunit_Desc: "Description de l'UO",
  Description: 'Description',
  Content: 'Contenu',
  Content2: 'Contenu 2',
  Content3: 'Contenu 3',
  Content4: 'Contenu 4',
  Content5: 'Contenu 5',
  Workload: 'Charge de travail',
  Price: 'Prix',
  Total: 'Total',
  Complexity: 'Complexité',
  deliverableDate: 'Date de livraison initiale',
  forcastedDate: 'Nouvelle date prévue',
  Scope: 'Périmètre',
  Client: 'Client',
  Edit_Client: 'Modifier le client',
  Submitted: 'Soumis',
  Dm_Validation: 'Validation du DM',
  Accepted: 'Accepté',
  Rating: 'Évaluation',
  Submit: 'Soumettre',
  Modify: 'Modifier',
  Duplicate: 'Dupliquer',
  Duplicate_Quote: 'Dupliquer le devis',
  Duplicate_Quote_Confirmation_Text:
    'Voulez-vous dupliquer ce devis ? Une fois dupliqué, la copie retourne dans les devis',
  Duplicate_TM_Order_Confirmation_Text:
    'Voulez-vous dupliquer cette commande en Assistance Technique ? Une fois dupliquée, la copie retourne dans les brouillons',
  Dont_Copy: 'Ne pas copier',
  Restore: 'Restaurer',
  Restore_Account: 'Restaurer le compte',
  Restore_Success: 'Le compte a été restauré avec succès',
  Cancel_Validation: 'Annuler la validation',
  Cancel_Submission: 'Annuler la soumission',
  Cancel: 'Annuler',
  OK: 'OK',
  Close_Order: 'Clôturer la commande',
  Close_Order_Confirmation_Text:
    'Vous êtes sur le point de clôturer la commande {{orderId}}, tous les livrables non révisés par votre client seront annulés. Voulez-vous continuer ?',
  Order_Closed_Message: "La commande avec l'ID {{orderId}} est clôturée",
  Reopen_From_Order_Close_Page: 'Vous pouvez toujours la rouvrir depuis la page de clôture de commande',
  Error_Occurred: 'Une erreur est survenue !',
  Please_Provide_Reason_Cancellation: "Veuillez indiquer une raison pour l'annulation :",
  Enter_Reason_Here: 'Entrez la raison ici...',
  Understood: 'Compris',
  Reason_For_Cancellation: "Raison de l'annulation",
  Reason_Is_Mandatory: 'La raison est obligatoire.',
  To_Be_Sent: 'À envoyer',
  Waiting_For_Signature: 'En attente de signature',
  To_Be_Signed: 'À signer',
  Error_Reported: 'Erreur signalée',
  Finished: 'Terminé',
  Delete: 'Supprimer',
  Cancel_Assessment: "Annuler l'évaluation",
  External_Broadcasted: 'Diffusé au client',
  Cancel_Refusal: 'Annuler le refus',
  Cancel_Comment: 'Annuler le commentaire',
  Cancel_Acceptance: "Annuler l'acceptation",
  Not_Disclosed: 'Non divulgué',
  Select_Wu_Catalog: 'Sélectionnez un catalogue',
  No_Archived_Catalogs: 'Aucun catalogue archivé',
  No_Archived_Clients: 'Aucun client archivé',
  Document_Title: 'Titre du document',
  Search_By_Name_Or_Ref: 'Rechercher par nom de projet ou référence',
  Create_New_Quote: 'Créer un nouveau devis',
  Add_Deliverable: 'Ajouter un livrable',
  Reset_All: 'Tout réinitialiser',
  Archives: 'Archives',
  Used_Complexity: "Cette complexité est utilisée dans une unité d'oeuvre",
  Details: 'Détails',
  No_Alerts: "Vous n'avez actuellement aucune alerte",
  See_Details: 'Voir les détails',
  Hide_Details: 'Masquer les détails',
  Extract_In_Pdf: 'Exporter en PDF',
  Extract_In_Excel: 'Exporter en Excel',
  Reset_Password: 'Renvoyer le mot de passe temporaire',
  Confirm_Client_Reset_Password: 'Confirmer le renvois du mot de passe client',
  Confirm_Reset_Password: 'Confirmer le renvois du mot de passe',
  Remember_Check_Spams: 'Pensez à vérifier votre dossier de courriers indésirables',
  Client_Parameters: 'Paramètres du client',
  Yes: 'Oui',
  No: 'Non',
  Client_Connection_Platform: 'Connexion du client à la plateforme',
  Accept_Dm: 'Accepté par le DM',
  Reserve_Dm: 'Accepté avec réserve par le DM',
  Refuse_Dm: 'refusé par le client',
  Assessed_Dm: 'Evalué par le DM',
  Financial: 'Financier',
  Technical: 'Technique',
  Document_Location: 'Emplacement du document',
  Signed_By_Dm: 'Signé par le DM',
  Deactivate_Schedule_Anonymize: "Désactiver et planifier l'anonymisation",
  Deactivate_Anonymize: 'Désactiver et anonymiser immédiatement',
  Deactivate: 'Désactiver',
  Deactivate_User: "Désactiver définitivement le compte l'utilisateur",
  Unassign_User: "Retirer l'utilisateur de ce compte client",
  Unassign_User_Button: "Retirer l'utilisateur de ce compte client",
  Confirm_Unassign_User: "Êtes-vous sûr de vouloir retirer l'utilisateur de ce client ?",
  Schedule_Anonymize_Tooltip: "Planifier l'anonimisation",
  Anonymize_Tooltip: 'anonymiser_infobulle',
  Confirm_Delete_Videos: 'Êtes-vous sûr de vouloir supprimer cette vidéo ?',
  Confirm_Guide_Videos: 'Êtes-vous sûr de vouloir supprimer ce guide ?',
  Open_Access_Confirm: 'Vous êtes sur le point d’ouvrir l’accès au client',
  Continue: 'Continuer',
  Open_Access_Temp_Pass: 'Mot de passe temporaire',
  Note: 'Note :',
  Confirmation: 'Confirmation',
  Change_Baseline_Confirmation_Text: 'Êtes-vous sûr de vouloir changer la référence de cette commande ?',
  Baseline_Change_Note: 'Note de modification de la référence',
  Baseline_Cancel_Note: "Note d'annulation de la référence",
  Baseline_Pagename: 'nom de page de référence',
  Save_Next: 'Enregistrer et suivant',
  Engagement_Parameters: 'Paramètres de la mission',
  Affectation: 'Affectation',
  Order_Summary: 'Résumé de la mission',
  Engagement_Subtitle: 'sous-titre de la mission',
  New_Baseline_Subtitle: 'sous-titres de la nouvelle référence',
  Affectation_Subtitle: "sous-titre de l'affectation",
  Order_Summary_Subtitle: 'Résumé de la commande',
  Edit_Baseline: 'Modifier la référence',
  baseLine_done: 'Référence Terminée',
  Ai_Agent: 'Agent IA',
  Help: 'Aide',
  Total_Workunits: "Nombre total d'unités d'oeuvre",
  Cancel_Delete: 'Annuler la suppression',
  Newwu: "Nouvelle unité d'oeuvre",
  Cancel_Newwu: "Annuler la nouvelle unité d'oeuvre",
  Version_History: 'Historique des versions',
  Kpi_Metrics: 'Indicateurs KPI',
  To_Do: 'À faire',
  Dashboard: 'Tableau de bord',
  Workflow: 'Flux de travail',
  Acceptance: 'Acceptation',
  Performance: 'Performance',
  Cover_Ratio: 'Ratio de couverture',
  Financial_Kpi: 'KPI Financier',
  Financial_Table: 'Tableau Financier',
  Purchase_Order: "Commande d'achat",
  Metrics: 'Métriques',
  Affair_Otp: 'OTP de la mission',
  Pending_At: 'En attente de',
  Kpi_Rating: 'Évaluation',
  Kpi_Status: 'Statut des indicateurs',
  Kpi_Delivery_Status: 'Indicateur de statut de livraison',
  Export_Table_Data: 'Exporter les donnees du tableau',
  Skip_Assessment: 'Ignorer l’evaluation',
  Refuse: 'Refuser',
  Submitted: 'Soumis',
  Not_Submitted: 'Non soumis',
  To_Be_Validated: 'À valider',
  Validation_Complete: 'Validation terminée',
  Pending_Submission: 'En attente de soumission',
  To_Be_Accepted: 'À accepter',
  Acceptance_Complete: 'Acceptation terminée',
  Pending_Delivery: 'En attente de livraison',
  Todo_Create_Order: "A faire création d'un order",
  Contect_Admin_Config_Tenant_Workmonth: 'Données manquantes. Contactez l’administrateur de l’espace',
  Reload_User_Permissions: 'Recharger les autorisations de l’utilisateur',
  '2_Characters_Minimum': '2 caractères minimum',
  Level_Standarad_Workunit: "Niveau Standard de l'Unité d'Oeuvre",
  Confirm: 'Confirmer',
  Confirm_Data_Anonymization: 'Confirmer l’anonymisation des données',
  Confirm_Schedule_Anonymization: 'Confirmer la planification de l’anonymisation',
  Schedule_Anonymize_Confirm_Text: "Message de confirmation de la planification de l'anonymisation",
  Confirm_Anonymize_Data_Now: "Confirmer l'anonymisation immédiate des données",
  Baseline_Change_Note: 'Note de modification de la référence',
  Baseline_Cancel_Note: "Note d'annulation de la référence",
  Baseline_Pagename: 'page Référence',
  Next_Tm: 'Suivant',
  Base_Line_Done: 'Référence Terminée',
  Quote: 'Devis',
  Define_Parameters: 'Définir les paramètres',
  Workunits: 'Unités d’œuvre',
  Select_Workunits: 'Sélectionner les unités d’œuvre',
  Switch_Client: 'Changer de client',
  Search_Client: 'Rechercher un client',
  MFA_Title: 'Titre MFA',
  MFA_Status_Title: 'Titre Statut MFA',
  MFA_Enabled: 'MFA Activé',
  MFA_Disabled: 'MFA Désactivé',
  MFA_Description: 'MFA Description',
  MFA_Important: 'MFA Important',
  MFA_Notice_Intro: "Avis d'introduction du MFA",
  MFA_Notice_Admin: 'Avis MFA administrateur',
  MFA_Important_Message: 'Message important MFA',
  MFA_Setup_Required: 'Configuration de la MFA requise :',
  MFA_Setup_Required_Message: 'Message de confirmation de la MFA requise',
  MFA_Disable_Confirm_Title: 'Titre de confirmation de la désactivation du MFA',
  MFA_Disable_Confirm_Text: 'Texte de confirmation de la désactivation du MFA',
  Cancel_Label: 'Annuler',
  Admin_MFA_Title: 'Titre Administrateur MFA',
  Client_Type: 'Type de client',
  Search_Users: 'Rechercher des utilisateurs',
  Enable_MFA: 'Activer la MFA',
  Disable_MFA: 'Désactiver la MFA',
  Clear_Selection: 'Effacer la sélection',
  Table_Name: 'table des noms',
  Table_Email: 'Table des email',
  Table_Client_Type: 'Table des Types client',
  Table_MFA_Status: 'table de Statut MFA',
  Table_Method: 'Table de Méthode',
  Table_Setup_Completed: 'table de Configuration terminée',
  Table_Actions: 'table Actions',
  No_Users_Found: 'Aucun utilisateur trouvé',
  No_Contacts_Found: 'Aucun contact trouvé',
  Users_Selected: 'utilisateur(s) sélectionné(s)',
  Internal_User: 'Utilisateur Interne',
  External_User: 'Utilisateur Externe',
  Yes_Label: 'Oui',
  No_Label: 'Non',
  MFA_Method_Label: 'Méthode MFA',
  Authenticator_App_Label: 'Application d’authentification',
  Authenticator_App_Subtext: 'Application d’authentification',
  Email_OTP_Label: 'Email OTP',
  Email_OTP_Subtext: 'Email OTP',
  Enable_MFA_User_Title: 'Activer le MFA pour cet utilisateur',
  Disable_MFA_User_Title: 'Désactiver le MFA pour cet utilisateur',
  Enable_MFA_User_Text: 'Désactiver le MFA pour cet utilisateur',
  Disable_MFA_User_Text: 'Désactiver le MFA pour cet utilisateur',
  Enable_MFA_Multiple_Title: 'Activer le MFA pour plusieurs utilisateurs',
  Disable_MFA_Multiple_Title: 'Désactiver la MFA pour plusieurs utilisateurs',
  Enable_MFA_Multiple_Text: 'Activer le MFA',
  Disable_MFA_Multiple_Text: 'Désactiver le MFA',
  Backlog: 'Backlog',
  Production_Title: 'Production',
  Control_Title: 'Contrôle',
  To_Deliver_Label: 'À livrer',
  Submitted_Label: 'Soumis',
  Reforcast_Label: 'Replanifié',
  Canceled_Label: 'Annulé',
  Validated_Label: 'Validé',
  Validated_With_Reservations: 'Validé avec réserves',
  Refused_Label: 'Refusé',
  Waiting_For_Validation: 'En attente de validation',
  Accepted_Label: 'Accepté',
  Accepted_With_Reservation: 'Accepté avec réserve',
  Client_Title: 'Client',
  Waiting_For_Acceptance: 'En attente d’acceptation',
  Waiting_For_Assessment: 'En attente d’évaluation',
  Quality_Title: 'Qualité',
  Average_Note: 'Note moyenne',
  Rated_2: 'Noté 2',
  Rated_1: 'Noté 1',
  Search_Consultant: 'Rechercher un consultant',
  Mission_Total: 'Nombre total de missions',
  Mission_In_eDelivery: 'Missions dans e-Delivery',
  Mission_Not_In_eDelivery: 'Missions absentes d’e-Delivery',
  Cover_Ratio: 'Taux de couverture',
  Country: 'Pays',
  Customers: 'Comptes Clients',
  OTP: 'OTP',
  DM: 'DM',
  Deliverable_Status: 'Statut du livrable',
  Order_ID: 'ID de la mission',
  Order_Type: 'Type de mission',
  PO: 'Numéro de commande',
  Customer_Site: 'Site client',
  Star_Rating: 'Note en étoiles',
  Business_Manager: 'Business Manager',
  Chef_De_Mission: 'Delivery Manager',
  Administrateur: 'Administrateur',
  Directeur_BU: 'Directeur de BU',
  Deactivated: 'Désactivé',
  Role: 'Rôle',
  Categories: 'Catégories',
  Select_Consultant: 'Sélectionner un consultant',
  Select_Delivery_Managers: 'Sélectionner les Delivery Managers',
  Select_Representative: 'Sélectionner un représentant',
  Engagement: 'Engagement',
  Dates: 'Dates',
  ID: 'ID',
  Select_Engagement: 'Sélectionner un engagement',
  Otp_Name: 'Nom OTP',
  Select_Scope: 'Sélectionner un périmètre',
  Select_Client: 'Sélectionner un client',
  Select_Business_Manager: 'Sélectionner un business manager',
  Select_Delivery_Manager: 'Sélectionner un delivery manager',
  Select_Order_Id: 'Sélectionner un ID de commande',
  Select_OrderWorkUnits_ID: "Sélectionner un ID d'unité d'œuvre de commande",
  Filter_Categories: 'Filtrer les catégories',
  Start_Month: 'Mois de début',
  End_Month: 'Mois de fin',
  Currency: 'Devise',
  Copy: 'Copier',
  Download: 'Télécharger',
  Feedback: 'Retour',
  Date: 'Date',
  Date_From: 'Date de début',
  Date_To: 'Date de fin',
  Ask_Me_Something: 'Posez-moi une question...',
  Share_Comments_Placeholder: 'Partager commentaires',
  Search_Placeholder: 'Rechercher',
  Search_Status_Placeholder: 'Rechercher un statut',
  Select_Option: 'Sélectionner une option',
  Select_All: 'Tout sélectionner',
  Select_Status_Placeholder: 'Sélectionner un statut',
  Select_Tenants: 'Sélectionner un espace client',
  Filter_By_Scopes: 'Filtrer par périmètre(s)',
  View_More_Categories: 'Afficher plus de catégories',
  View_More_Users: 'Afficher plus d’utilisateurs',
  Create_Own_Scope: 'Créer votre propre périmètre',
  No_Workunits_Catalog: "Aucun catalogue d'UO",
  Deactivate_Notifications: 'Désactiver les notifications',
  Minimal_Notifications: 'Notifications minimales',
  Realtime_Notifications_Default: 'Notifications en temps réel (par défaut)',
  Affect_Every_Page: 'Appliquer à toutes les pages',
  Deactivate_Anonymize_Now: "Désactiver l'anonymisation immédiate",
  Deactivate_Schedule_Anonymization: 'Désactiver la planification de l’anonymisation',
  Accept_Terms_Checkbox: 'Acceptation des conditions générales d’utilisation',
  Copy_Response: 'Copier la réponse',
  Like_Response: 'Aimer cette réponse',
  Dislike_Response: 'Je n’aime pas cette réponse',
  Expand_Row: 'Développer la ligne',
  More_Actions: "Plus d'action",
  Placeholder_Text: 'Espace Texte',
  Range_Option: 'Plage',
  Single_Option: 'Unique',
  Rated_Zero: 'Noté 0',
  All_Option: 'TOUS',
  Tooltip_Scope_Rows: 'Lignes périmètre',
  Tooltip_PO_Amount: 'Montant de la commande',
  Tooltip_Cancel_Incorporation: 'Annuler l’intégration',
  Tooltip_Cancel_Deletion: 'Annule la suppression',
  Tooltip_Incorporate_WU: 'Intégrer une unité d’œuvre',
  Tooltip_Reintegrate_WU: 'Réintègrer une unité d’œuvre',
  Tooltip_Remove_WU: 'Supprime une unité d’œuvre',
  Tooltip_Tab_Switch: 'Changement donglet',
  Error_End_Date_Expired: 'La date de fin est dépassée',
  PO_Reference: 'Référence de la commande',
  No_Data_Found: 'Aucune donnée trouvée',
  Email_Notifications: 'Notifications par e-mail',
  Mode: 'Mode :',
  View: 'Vue :',
  By_Month: 'Par mois',
  By_Date: 'Par date',
  Deliverables_Assessment: 'Évaluation des livrables',
  Share_Your_Ratings: 'Partagez vos évaluations',
  Skip_Note: 'Ignorer',
  Without_Rating_Status: 'Statut Sans évaluation',
  Skip: 'Ignorer',
  Dashboard_Notifications_Title: 'Notifications du tableau de bord',
  Critical_Account_Notifications: 'Compte critique',
  Receive_Every_Update: 'Recevez chaque mise à jour',
  Key_Updates_Only: 'Recevez uniquement les mises à jour essentielles',
  Stay_Distraction_Free: 'Restez concentré sans alertes',
  Loading_Chart: 'Chargement du graphique',
  Report_Generated_Successfully: 'Rapport généré avec succès',
  Vertical_Tabs_Example: 'Exemple d’onglets verticaux',
  Disabled_Tabs_Example: 'Exemple d’onglets désactivés',
  Quick_Access_Tabs: 'Accès rapide',
  Collapsible_Table: 'Tableau repliable',
  Basic_Tabs_Example: 'Exemple d’onglets simples',
  Settings: 'Paramètres',
  Delivery_Manager: 'Delivery Manager',
  BM: 'BM',
  BU_Support: 'BU Support',
  Hide_All: 'Tout masquer',
  Show_All: 'Tout afficher',
  Complete: 'Terminé',
  Pending_Client: 'En attente du client',
  Pending_DM: 'En attente du DM',
  Pending_Consultant: 'En attente du consultant',
  EDelivery: 'E-Livraison',
  Deliverable: 'Livrable',
  Reference: 'Référence',
  Create_Report: 'Créer un rapport',
  Create_Technical_Report: 'Créer un rapport technique',
  Create_Financial_Report: 'Créer un rapport financier',
  Enter_Title_Technical_Report: 'Entrez un titre pour votre rapport de suivi technique',
  Enter_Title_Financial_Report: 'Entrez un titre pour votre rapport de suivi financier',
  Your_Title: 'Votre titre',
  Select_Scopes_For_Report: 'Sélectionnez le(s) périmètre(s) que vous souhaitez inclure dans votre rapport',
  Select_Production_For_Report: 'Sélectionnez la production que vous souhaitez inclure dans votre rapport',
  No_Date_Found_For_Scope: 'Aucune date trouvée pour ce périmètre',
  Or: 'Ou',
  Select_Deliverables_By_Hand: 'sélectionner les livrables manuellement',
  Deliverable_Selected: 'Livrable sélectionné',
  Deliverables_Selected: 'livrables sélectionnés',
  Select_At_Least_One_Scope_And_Date:
    'Sélectionnez au moins un périmètre et une date, ou sélectionnez les livrables manuellement pour afficher les clients',
  Select_Clients_Only_Assigned: 'Sélectionnez les clients qui ne recevront que les livrables qui leur sont assignés',
  Select_Client_All_Deliverables: 'Ou sélectionnez le client qui recevra tous les livrables de la production',
  Are_You_Sure_Create_Report: 'Êtes-vous sûr de vouloir créer un rapport ?',
  Will_Lose_Progress: 'Vous perdrez toute votre progression',
  Confirm_Report_Creation: 'Confirmer la création du rapport',
  Cancel_Report_Creation: 'Annuler la création du rapport',
  Missing_Required_Fields: 'Champs obligatoires manquants',
  All_Production: 'Toute la production',
  Send_To_Client: 'Envoyer au client',
  Mark_As_Signed: 'Marquer comme signé',
  Download_Document: 'Télécharger le document',
  Delete_Report: 'Supprimer le rapport',
  Cancel_The_Sending: "Annuler l'envoi",
  Preview: 'Aperçu',
  Filters: 'Filtres',
  // KPI Metrics dropdown - section headers (EDD-424)
  Delivery: 'Livraison',
  'Coverage & Data Completeness': 'Couverture et exhaustivité des données',
  // Financial Table status matrix - row labels (EDD-424)
  Purchased: 'Acheté',
  Baseline: 'Référence',
  Postponed_Out: 'Reporté (sortant)',
  Postponed_In: 'Reporté (entrant)',
  Forecasted: 'Prévisionnel',
  Validated_Dm: 'Validé DM',
  Refused_Client: 'Refusé Client',
  Accepted_Client: 'Accepté Client',
  Invoiced: 'Facturé',
  // KPI Metrics tab - filter panel toggle button (EDD-424)
  Filter: 'Filtrer',
  // Financial KPI - income completion table (EDD-424)
  Purchased_Contractual: 'Acheté (contractuel)',
  To_Date: 'À CE JOUR',
  At_Completion: "À l'achèvement",
  Purchased_Planned: 'Acheté (planifié)',
  Tooltip_Purchased_Planned: 'Montant mensuel de la commande défini par le service commercial.',
  Tooltip_Baseline: "Montant des unités d'œuvre initialement chargées dans e-Delivery lors de la création du devis.",
  Tooltip_Forecasted: 'Prévisionnel = Référence - Annulé + Ajouté - Reporté (sortant) + Reporté (entrant)',
  Tooltip_Accepted_Client: "Montant des unités d'œuvre acceptées par le client",
  Tooltip_Invoiced: 'Montant réel facturé au client.',
  Delta_Forecasted_Baseline: 'Écart "Prévisionnel - Référence"',
  Delta_Forecasted_Purchased: 'Écart "Prévisionnel - Acheté"',
  Delta_Invoiced_Purchased: 'Écart "Facturé - Acheté"',
  // Order card menu (EDD-424)
  Change_Baseline: 'Changer Baseline',
  Cancel_Change_Baseline: 'Annuler Changer Baseline',
  Download_Excel: 'Télécharger en Excel',
  Reopen: 'Réouvrir',
  // Order card content - dates and progress bars (EDD-424)
  Created_On: 'Créé le',
  Modified_On: 'Modifié le',
  Realised: 'Réalisé',
  // Tenant settings - workload page (EDD-424)
  Daily: 'Quotidien',
  Days: 'Jours',
  Hours: 'Heures',
  // Deliverables page - back navigation (EDD-424)
  Back: 'Retour',
  // Order summary datagrid - display mode & row titles (EDD-424)
  Quarterly: 'Trimestriel',
  Daily_Rate: 'Taux journalier',
  Fte: 'FTE',
  // Excel extraction dialogs (EDD-424)
  Excel_Extraction: 'Extraction Excel',
  Extract_Excel_Confirm: 'Voulez-vous extraire les fichiers Excel ?',
  Dont_Extract: 'Ne pas extraire',
  Extract: 'Extraire',
  Reference_Details: 'Détails des références',
  Spec_Ref: 'Réf. spécification',
  Chrono_Ref: 'Réf. chrono',
  // KPI Acceptance page - donut/table/bar chart labels (EDD-424)
  To_Be_Done: 'À faire',
  Number: 'Nombre',
  Order_Date_Change_Confirm:
    'Vous êtes sur le point de modifier la période de la mission. Les unités d’œuvre situées en dehors de la nouvelle période seront annulées. Souhaitez-vous continuer ?',
  Order_Date_Change_Blocked:
    'Les dates de la mission ne peuvent pas être modifiées car une ou plusieurs unités d’œuvre de la période sélectionnée ont déjà été soumises.',
  Order_Date_Change_Title: 'Modification de la période impossible',
  Order_Date_Change_Check_Failed:
    'Impossible de vérifier les unités d’œuvre soumises. Les dates de la mission n’ont pas été enregistrées.',
  Order_Date_Change_Remove_Failed:
    'Les unités d’œuvre hors de la nouvelle période n’ont pas pu être annulées. Les dates de la mission n’ont pas été enregistrées.',
  Order_Date_Change_Cancel_Reason: 'Période de la mission modifiée',
  Order_Date_Change_Save_Failed:
    'La mission n’a pas pu être enregistrée. Les dates de la mission et les unités d’œuvre n’ont pas été modifiées.',
  Order_Date_Change_Restore_Failed:
    'Les dates de la mission n’ont pas été enregistrées et les unités d’œuvre annulées n’ont pas pu être restaurées. Veuillez les restaurer depuis la page Livrables.',
  // ===== NOUVEAU : PopriceDashboard - Tableau de synthèse financière des commandes (EDD-424) =====
  Orders: 'Commandes',
  Years: 'Années',
  Tooltip_Purchased: 'Montant de la commande fourni par le service commercial',
  Tooltip_Cancelled: "Montant des unités d'œuvre annulées.",
  Tooltip_Added: "Montant des unités d'œuvre ajoutées.",
  Tooltip_Submitted: "Montant des unités d'œuvre soumises par le consultant.",
  Tooltip_Validated_Dm: "Montant des unités d'œuvre validées par le DM.",
  // ===== FIN NOUVEAU =====
};

export default fr;
